// extracted by mini-css-extract-plugin
module.exports = {"pricesRealizedFilterContainer":"filters-module--pricesRealizedFilterContainer--2chhr"};